import {useAppDispatch, useListFilterValues} from "../../../../hooks/hooks";
import {useCallback, useEffect, useMemo, useState} from "react";
import {
    OrganManagerShareDTO,
    OrganManagerShareListQueryType,
    OrganShareSearchCondition
} from "../../../../types/organShare";
import {
    DEFAULT_PAGE,
    DEFAULT_SIZE,
    DEFAULT_SORT,
    ordersToSortArr,
    PageResponse,
    PageSearchCondition
} from "../../../../types/page";
import {getOrganManagerShareListAsync} from "../../../../store/organShareSlice";
import {DEFAULT_PAGE_RESPONSE} from "../../../../util/etcUtil";
import {useUtil} from "../../../../util/hooks/useUtil";
import {useSortParam} from "../../../../hooks/list/useSortParam";

export function useOrganManagerShareGetter() {
    const {defaultErrorMessage} = useUtil();
    const dispatch = useAppDispatch();
    const [totalCount, setTotalCount] = useState<number | null>(null)
    const [organShareManagerList, setOrganShareManagerList] =
        useState<PageResponse<OrganManagerShareDTO>>(DEFAULT_PAGE_RESPONSE)

    const {filterValues, searchList, listQueryType} = useListFilterValues();
    const {toSortArray} = useSortParam();

    const getOrganManagerShareList = useCallback(
        async (param: OrganShareSearchCondition, isFirstLoad?: boolean) => {
            try {

                const result: PageResponse<OrganManagerShareDTO> = await dispatch(getOrganManagerShareListAsync(param)).unwrap();
                setOrganShareManagerList(result)
                setTotalCount(result.totalElements);

                if (isFirstLoad) {
                    setTotalCount(result.totalElements);
                } else {
                    setOrganShareManagerList(result);
                }

            } catch (e) {
                alert(defaultErrorMessage);
            }
        },
        //eslint-disable-next-line
        []
    );

    const getCounselorListWithParam = useCallback(
        (isFirstLoad?: boolean) => {
            if (isFirstLoad) {
                getOrganManagerShareList({}, true).then();
            }

            const organListQueryType = listQueryType as OrganManagerShareListQueryType;
            getOrganManagerShareList({
                pageCondition: {
                    page: organListQueryType.page ? Number(organListQueryType.page) : DEFAULT_PAGE,
                    size: organListQueryType.size ? Number(organListQueryType.size) : DEFAULT_SIZE,
                    sort: organListQueryType.sort ? toSortArray(organListQueryType.sort) : DEFAULT_SORT,
                },

                query: searchWordFilterValue.value ? searchWordFilterValue.value.trim() : undefined,
                query_type: searchWordTypeFilterValue.value,
            }).then();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [listQueryType]);

    const {
        searchWordTypeFilterValue,
        searchWordFilterValue,
    } = filterValues;

    const searchOrganManagerShareList = (pageSearchCondition: PageSearchCondition) => {
        const param: OrganManagerShareListQueryType = {
            searchWordType: searchWordTypeFilterValue.value,
            searchWord: searchWordFilterValue.value ? searchWordFilterValue.value.trim() : undefined,
        };

        return () => {
            searchList(pageSearchCondition, param)();
        }
    };

    useEffect(() => {
        if (listQueryType) {
            getCounselorListWithParam();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCounselorListWithParam]);

    // page condition
    const pageCondition = useMemo(
        () => ({
            page: organShareManagerList?.number ?? DEFAULT_PAGE,
            size: organShareManagerList?.size ?? DEFAULT_SIZE,
            sort: ordersToSortArr(organShareManagerList?.orders),
        }),
        [organShareManagerList]
    );

    return{
        organShareManagerList,
        pageCondition,
        totalCount,
        searchOrganManagerShareList,
        getOrganManagerShareList
    }
}